module.exports = __webpack_public_path__ + "static/media/under_construction.c31a80ba.jpg";